<template>
  <div style="margin-top: -25px; color: #081c36; font-family: 'Segoe UI'">
    <div
      class="divider-custom-zalo mb-3"
      style="margin-right: -20px; margin-left: -20px" />

    <el-input
      ref="input"
      placeholder="Tìm kiếm hội thoại cần chia sẻ..."
      size="large"
      clearable
      v-model="searchKey"
      @input="searchKeyChanged()"
      prefix-icon="el-icon-search"></el-input>
    <div class="mb-3"></div>
    <div
      id="tag-container"
      style="padding: 5px; border: 1px solid #e0e4e8; border-radius: 10px; max-height: 64px; overflow: auto">
      <span
        v-for="item in app.tags"
        class="me-2"
        :key="item.id"
        @click="addOrRemoveTag(item)">
        <TagCustom
          :item="item"
          :selected="isSelected(item)"
          :is-button="true" />
      </span>
    </div>
    <div class="mb-3"></div>
    <div class="divider-custom-zalo"></div>
    <div class="d-flex">
      <div style="flex: 1">
        <div
          class="add-share-popup-left"
          style="flex: 1">
          <div
            style="color: #081c36;font-family: 'Segoe UI,serif,serif"
            class="fw-semibold mb-1 mt-1">
            Các cuộc trò chuyện
          </div>
          <div
            class="select-item rounded-2"
            v-for="item in views"
            :key="item.id">
            <div
              class="d-flex py-2 pointer align-items-center"
              @click.stop.prevent="selectItem(item)">
              <input
                style="margin: 0"
                type="checkbox"
                :checked="checkSelectedContact(item.id)"
                :id="'checkbox' + item.id" />
              <label :for="'checkbox' + item.id"></label>
              <el-image
                :src="item.avatar"
                style="border-radius: 1000px"
                class="mx-2 img-select">
                <div
                  slot="error"
                  class="image-slot">
                  <el-image
                    src="/assets/images/no-avatar.png"
                    style="border-radius: 1000px"
                    class="img-select"></el-image>
                </div>
              </el-image>
              <div class="d-flex flex-column">
                <div style="white-space: normal " class="flex-1 font-size-14 text-1-line fw-semibold text-grey900">{{ item.toName }}</div>
                <div style="white-space: normal " class="flex-1 font-size-14 text-1-line text-grey500">{{ item.swName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-1">
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :current-page="pageInfo.page"
            :total="pageInfo.total"
            :page-size="pageInfo.pageSize"
            @current-change="currentSwPageChanged"
            @prev-click="pageInfo.page -= 1"
            @next-click="pageInfo.page += 1"></el-pagination>
        </div>
      </div>
      <div
        class="position-absolute ms-2 mt-3"
        v-bind:style="conversationsSelected.length === 0 ? 'right:-50% ' : 'position:static !important'"
        :class="conversationsSelected.length > 0 ? 'left-group' : 'left-group no-item'">
        <div
          style="border: 1px solid #e0e4e8"
          class="rounded-2 p-2">
          <div
            class="font-size-14 fw-semibold mb-1"
            style="width: 100px">
            <div style="font-family: 'Segoe UI'; color: #081c36">
              Đã chọn
              <span
                class="ms-2 font-size-12"
                style="color: #005ae0; background-color: #f0f7ff">
                {{ conversationsSelected.length }}/{{ LIMIT }}
              </span>
            </div>
          </div>
          <div
            class="add-share-popup-right"
            style="overflow-y: auto; overflow-x: hidden">
            <div
              class="mb-1 me-2"
              style="background-color: #e5efff; color: #005ae0; width: 175px; border-radius: 1000px"
              v-for="item in conversationsSelected"
              :key="item.id">
              <div
                class="position-relative rounded-2 d-flex pointer d-flex align-items-center py-1"
                @click.stop.prevent="unSelect(item.id)">
                <!--                <el-avatar :src="item.avatar" class="ms-1 me-2 img-selected" />-->
                <el-image
                  :src="item.avatar"
                  style="border-radius: 1000px"
                  class="ms-1 me-2 img-selected">
                  <div
                    slot="error"
                    class="image-slot">
                    <el-image
                      src="/assets/images/no-avatar.png"
                      style="border-radius: 1000px"
                      class="img-selected"></el-image>
                  </div>
                </el-image>
                <div
                  style="white-space: normal"
                  class="text-1-line font-size-14 text-break me-1">
                  {{ item.toName }}
                </div>
                <img
                  src="/assets/icon/icon_close_fill_blue.svg"
                  style="margin-right: 10px; margin-left: auto; width: 15px; height: 15px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="divider-custom-zalo mt-1 mb-2"
      style="margin-right: -20px; margin-left: -20px" />
    <div class="mb-1">Nội dung chia sẻ</div>
    <div
      class="d-flex mt-1 pointer mb-1"
      v-if="shareContactCard ? true : false">
      <div class="mx-1 align-self-center">[Danh thiếp]</div>
    </div>
    <div v-else>
      <div
        class="d-flex mt-1 pointer mb-1"
        v-if="isPhoto || isVideo || isCardBusiness(message) || isFile || message.isArray">
        <img
          :src="getThumbUrl()"
          class="rounded-1"
          style="max-width: 32px; max-height: 32px; object-fit: contain" />
        <div
          v-if="groupImages.length > 0"
          class="mx-1 align-self-center">
          {{ groupImages.length }} ảnh được chọn
        </div>
        <div
          v-if="isCardBusiness(message)"
          class="mx-1 align-self-center">
          [Danh thiếp]
        </div>
        <div
          v-if="message.isArray"
          class="mx-1 align-self-center">
          {{ message.messages.length }} tệp được chọn
        </div>
      </div>
      <el-input
        v-if="groupLayoutId === '' && !isVideo && !isCardBusiness(message) && !isFile"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 2 }"
        v-model="messageContent"></el-input>
    </div>

    <div
      class="divider-custom-zalo mt-3"
      style="margin-right: -20px; margin-left: -20px" />

    <div class="d-flex justify-content-end mt-3">
      <span
        class="edit-button font-size-16 me-3 fw-semibold rounded-2 pointer py-2 px-3"
        @click="closeDialog()">
        Hủy
      </span>
      <!--      <span class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3" @click="send()">Chia sẻ</span>-->
      <el-button
        :disabled="isDisable"
        class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3"
        :loading="isDisable"
        @click="send">
        Chia sẻ
      </el-button>
    </div>
  </div>
</template>

<script>
import TagCustom from "../common/TagCustom";
import { COMMON } from "../../lib/Common";

export default {
  name: "SharePopup",
  components: { TagCustom },
  props: {
    accountId: String,
    message: Object,
    messageList: Array,
    shareContactCard: Object,
  },
  data() {
    return {
      isDisable: false,
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      searchKey: "",
      conversations: [],
      conversationsSelected: [],
      selectedTags: [],
      views: [],
      LIMIT: 100,
      messageContent: "",
      photoContent: {},
      groupLayoutId: "",
      groupImages: [],
    };
  },
  computed: {
    isFile() {
      return this.message.msgType === COMMON.CHAT_FILE;
    },
    isText() {
      return this.message.msgType === "webchat";
    },
    isPhoto() {
      return this.message.msgType === "chat.photo";
    },
    isVideo() {
      return this.message.msgType === COMMON.CHAT_VIDEO;
    },
  },
  watch: {
    selectedTags: function () {
      this.search();
    },
  },
  methods: {
    getThumbUrl() {
      if (this.isFile && Object.keys(this.photoContent).length > 1) {
        return this.fileTypeIcon(this.photoContent.extension);
      }
      let data = this.photoContent.thumbUrl;
      return data;
    },
    searchKeyChanged() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.getContact(true);
      }, 300);
    },
    getMsgType() {
      if (this.isText) {
        return 1;
      } else if (this.isPhoto) {
        return 2;
      } else if (this.isVideo) {
        return 5;
      } else if (this.isCardBusiness(this.message)) {
        return 6;
      } else if (this.isFile) {
        return 19;
      }
    },
    getMessage() {
      if (this.isText) {
        return this.messageContent;
      } else if (this.isPhoto) {
        this.photoContent.title = this.messageContent;
        return JSON.stringify(this.photoContent);
      } else if (this.isVideo) {
        return JSON.stringify(this.photoContent);
      } else if (this.isCardBusiness(this.message)) {
        delete this.photoContent.thumbUrl;
        return JSON.stringify(this.photoContent);
      } else if (this.isFile) {
        return JSON.stringify(this.photoContent);
      }
    },
    send() {
      if (this.shareContactCard) {
        return this.onSendContactCard();
      }

      let request = {
        accountId: this.accountId,
        toIds: this.conversationsSelected.filter((s) => s.group !== true).map((s) => s.toId),
        toGroupIds: this.conversationsSelected.filter((s) => s.group === true).map((s) => s.toId),
      };
      if (request.toIds.length === 0 && request.toGroupIds.length === 0) return this.alertError("Bạn chưa chọn cuộc trò chuyện");

      if (this.message.isArray) {
        if (this.message.type === COMMON.CHAT_FILE) {
          this.message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getFileParams(s)),
              msgType: 19,
            };
            this.isDisable = true;
            this.sendShareMessage(newRequest);
          });
          return;
        } else {
          this.message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getPhotoParams(s)),
              msgType: 2,
            };
            this.sendShareMessage(newRequest);
          });
          return;
        }
      }

      if (this.groupLayoutId === "") {
        request = {
          ...request,
          message: this.getMessage(),
          msgType: this.getMsgType(),
        };
        if (this.isText && this.getMessage().trim().length === 0) return this.alertError("Vui lòng nhập nội dung tin nhắn");
        this.isDisable = true;
        this.sendShareMessage(request);
      } else {
        this.isDisable = true;
        this.groupImages.forEach((s) => {
          request = {
            ...request,
            message: JSON.stringify(this.getPhotoParams(s)),
            msgType: 2,
          };
          this.sendShareMessage(request);
        });
      }
    },

    async onSendContactCard() {
      await Promise.all(
        this.conversationsSelected.map(async (conv) => {
          await this.$http.post("/api/message/sendContact", {
            accountId: this.shareContactCard.accountId,
            friendId: `${this.shareContactCard.accountId}_${this.shareContactCard.friendId}_0_0`,
            toId: conv.toId,
            conversationId: conv.id,
          });
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
      );
      this.closeDialog();
    },

    sendShareMessage(request) {
      this.$http
        .post("/api/message/forwardMessage", request)
        .then(() => {
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
        .finally(() => this.closeDialog());
    },
    closeDialog() {
      this.$emit("closeSharePopup");
    },
    search() {
      this.views = this.conversations
        .filter((s) => {
          if (s.toName === null) return;
          if (s.swName) {
            let isExist = s.swName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
            if (isExist) return true;
          }
          return s.toName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
        })
        .filter((s) => {
          if (this.selectedTags.length === 0) return true;
          else return s.tags.map((s) => s.id).some((t) => this.selectedTags.includes(t));
        });
    },

    addOrRemoveTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
      this.getContact(true);
    },

    isSelected(tag) {
      let index = this.selectedTags.indexOf(tag.id);
      return index > -1;
    },
    checkSelectedContact(id) {
      return this.conversationsSelected.findIndex((con) => con.id === id) !== -1;
    },
    selectItem(item) {
      if (this.conversationsSelected.length > this.LIMIT) return;
      let filter = this.conversationsSelected.filter((con) => con.id === item.id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      } else {
        this.conversationsSelected.push(item);
      }
    },
    unSelect(id) {
      let filter = this.conversationsSelected.filter((con) => con.id === id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      }
    },
    currentSwPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getContact();
    },
    getContact(search = false) {
      if (search) {
        this.pageInfo.page = 1;
      }
      let body = {
        accountId: this.accountId,
        searchKey: this.searchKey,
        selectedTags: this.selectedTags.length > 0 ? this.selectedTags : null,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        type: "all",
      };
      this.$http.post("/api/conversation/all", body).then((rep) => {
        this.pageInfo.total = rep.data.totalElements;
        this.views = rep.data.content;
        if (this.app.allGroupIds.has(body.accountId)) {
          let allGroupIds = this.app.allGroupIds.get(body.accountId);
          this.views = this.views.filter((s) => {
            if (s.group === true) {
              return !!allGroupIds.includes(s.toId);
            } else return true;
          });
        }
      });
    },
    getPhotoParams(item) {
      let photo = JSON.parse(item.content);
      let params = JSON.parse(photo.params);
      let data = {};
      data.title = photo.title;
      data.oriUrl = photo.href;
      data.thumbUrl = photo.thumb;
      data.hdUrl = params.hd;
      data.width = params.width;
      data.height = params.height;
      data.properties = null;
      data.normalUrl = photo.href;
      if (this.isPhotoGroup(item)) {
        data.totalItemInGroup = params.total_item_in_group;
        data.idInGroup = params.id_in_group;
        data.isGroupLayout = params.is_group_layout;
        data.groupLayoutId = params.group_layout_id;
      }
      return data;
    },
    isActionText() {
      try {
        let con = JSON.parse(this.message.content);
        if (["msginfo.actionlist", "rtf"].includes(con.action)) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },
    getVideoParams(message) {
      let content = JSON.parse(message.content);
      let params = JSON.parse(content.params);
      let item = {};
      item.videoUrl = content.href;
      item.thumbUrl = content.thumb;
      item.duration = params.duration;
      item.width = params.video_width;
      item.height = params.video_height;
      item.fileSize = params.fileSize;
      item.properties = null;
      return item;
    },
    getCardBusiness(message) {
      let content = JSON.parse(message.content);
      let uid = content.params;
      let item = {};
      item.contactUid = uid;
      let description = JSON.parse(content.description);
      item.qrCodeUrl = description.qrCodeUrl;
      if (description.phone) {
        item.phone = description.phone;
      }
      item.thumbUrl = content.thumb;
      return item;
    },
    getPhotoList() {
      this.messageList
        .filter((p) => p.msgType == "chat.photo")
        .forEach((item) => {
          let params = JSON.parse(JSON.parse(item.content).params);
          if (params.is_group_layout) {
            if (params.group_layout_id == this.groupLayoutId) {
              this.groupImages.push(item);
            }
          }
        });
    },
    getPhoto(photos, item) {
      let params = JSON.parse(JSON.parse(item.content).params);
      if (params.is_group_layout) {
        if (params.group_layout_id == this.groupLayoutId) {
          photos.push({ id: params.id_in_group, url: this.findUrlHDIfExist(item.content) });
        }
      }
    },
    getFileParams(message) {
      let content = JSON.parse(message.content);
      let msgInfo = {};
      msgInfo.url = content.href;
      msgInfo.fileName = content.title;
      let params = JSON.parse(content.params);
      msgInfo.extension = params.fileExt;
      msgInfo.checksum = params.checksum;
      msgInfo.fdata = params.fdata;
      msgInfo.fType = params.fType;
      msgInfo.size = params.fileSize;
      return msgInfo;
    },
  },
  mounted() {
    if (this.message.msgType === "webchat") {
      this.messageContent = this.isActionText() ? JSON.parse(this.message.content).title : this.message.content;
    } else if (this.message.msgType === "chat.photo") {
      this.photoContent = this.getPhotoParams(this.message);
      this.messageContent = this.photoContent.title;
      if (this.isPhotoGroup(this.message)) {
        if (JSON.parse(this.message.content).params) {
          let params = JSON.parse(JSON.parse(this.message.content).params);
          if (params.is_group_layout) {
            this.groupLayoutId = params.group_layout_id;
          }
        }
        this.getPhotoList();
      }
    } else if (this.isVideo) {
      this.photoContent = this.getVideoParams(this.message);
    } else if (this.isCardBusiness(this.message)) {
      this.photoContent = this.getCardBusiness(this.message);
    } else if (this.isFile) {
      this.photoContent = this.getFileParams(this.message);
    }
    this.$refs.input.focus();
    this.getContact();
  },
};
</script>

<style scoped>
.share-button:hover {
  background-color: #0a58c0;
}

.share-button {
  color: #fff;
  background-color: #0068ff;
}

.edit-button:hover {
  background-color: #b6bec9;
}

.edit-button {
  background-color: #eaedf0;
  /*margin-left: auto;*/
}

/*.select-item{*/
/*  border-radius: 5px;*/
/*}*/
.select-item:hover {
  background-color: #f1f4f8;
}

.img-selected {
  border: 1px solid #fff;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
}

.img-select {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
}

label {
  background-color: #fff;
  border: 3px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  min-height: 21px;
  left: 0;
  position: relative;
  top: 50%;
  max-width: 21px;
  min-width: 21px;
  max-height: 21px;
}

label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 3px;
  opacity: 0;
  position: absolute;
  top: 4px;
  transform: rotate(-45deg);
  width: 10px;
}

input[type="checkbox"] {
  visibility: hidden;
}

input[type="checkbox"]:checked + label {
  background-color: #0068ff;
  border-color: #0068ff;
}

input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.left-group:after {
  overflow: hidden;
}

.left-group {
  width: 200px;
  transition: width 1s;
  overflow: hidden;
  margin-bottom: 16px;

  /*float: right;*/
  /*background-color: #f1f4f8;*/
  /*!*width: 100px;*!*/
  /*height: 100%;*/
  /*animation: animateThis 0.2s cubic-bezier(0.42, 0, 1, 1);*/
  /*animation-fill-mode: forwards;*/
}

.no-item {
  visibility: hidden;
  width: 0;
  max-width: 0;
}

@keyframes animateThis {
  0% {
    width: 0;
    height: 100%;
  }
  100% {
    width: 100%;
    height: 100%;
  }
}

.add-share-popup-left {
  height: 240px;
  overflow-y: auto;
}

.add-share-popup-right {
  height: 160px;
  overflow-y: auto;
}

#tag-container::-webkit-scrollbar {
  display: none;
}
</style>